import {
  AudioUploadTransport,
  AudioUploadTransportInput,
  UploadTransportResult,
} from "@/store/audio/uploading/audio-uploading.types";
import { DesktopAudioArtifactRef } from "@/modules/electron/types";
import { WebAudioArtifactRef } from "@/modules/audio-recording/web-artifacts";
import {
  isDesktopAudioArtifactRef,
  isWebAudioArtifactRef,
  RendererAudioUploadSource,
} from "@/store/audio/uploading/renderer-audio-upload-source";

type RecordingStrategyAudioUploadTransportConfig = {
  webTransport: AudioUploadTransport<WebAudioArtifactRef>;
  desktopTransport: AudioUploadTransport<DesktopAudioArtifactRef>;
};

export class RecordingStrategyAudioUploadTransport
  implements AudioUploadTransport<RendererAudioUploadSource>
{
  private readonly webTransport: AudioUploadTransport<WebAudioArtifactRef>;
  private readonly desktopTransport: AudioUploadTransport<DesktopAudioArtifactRef>;

  constructor({ webTransport, desktopTransport }: RecordingStrategyAudioUploadTransportConfig) {
    this.webTransport = webTransport;
    this.desktopTransport = desktopTransport;
  }

  upload({
    source,
    uploadMeta,
    forceRestart,
    onProgress,
  }: AudioUploadTransportInput<RendererAudioUploadSource>): Promise<UploadTransportResult> {
    if (isWebAudioArtifactRef(source)) {
      return this.webTransport.upload({
        source,
        uploadMeta,
        forceRestart,
        onProgress,
      });
    }

    if (isDesktopAudioArtifactRef(source)) {
      return this.desktopTransport.upload({
        source,
        uploadMeta,
        forceRestart,
        onProgress,
      });
    }

    return Promise.resolve({
      success: false,
      error: "Unsupported upload source",
    });
  }
}
